export default __webpack_public_path__ + "static/media/workplace_illustration.2f250c6a.svg";